import Overlay from 'ol/Overlay.js';

// Get the popup and its content and closer elements
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

// Create an OpenLayers Overlay for the popup
const popupOverlay = new Overlay({
    element: container,
    autoPan: {
        animation: {
            duration: 250,
        },
    },
});

// Add a click handler to the closer button to hide the popup
closer.onclick = function() {
    popupOverlay.setPosition(undefined);
    closer.blur();
    return false;
};

/**
 * Function to show the popup.
 * @param {string} stationName - The name of the station.
 * @param {number} windSpeed - The wind speed.
 * @param {ol.Coordinate} coordinate - The map coordinate to position the popup.
 */
function showPopup(stationName, windSpeed, coordinate) {
    content.innerHTML = `<b>${stationName}</b><br>Velocidad Viento: ${windSpeed.toFixed(2)} km/h`; // Display wind speed with 2 decimal places
    popupOverlay.setPosition(coordinate);
}

/**
 * Function to hide the popup.
 */
function hidePopup() {
    popupOverlay.setPosition(undefined);
}

// Export the popup overlay and functions
export { popupOverlay, showPopup, hidePopup };